import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './lobbo.css';
import './responsive.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Service worker (PWA / offline)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
